<template>
  <div class="container">
    <div class="handle-box">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
    </div>
    <el-table :data="couponData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      :cell-style="centerStyle">
      <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="meet_amount" label="使用门槛" align="center">
        <template #default="scope">
          {{ scope.row.meet_amount / 100 }}
        </template>
      </el-table-column>
      <el-table-column prop="use_amount" label="优惠金额" align="center">
        <template #default="scope">
          {{ scope.row.use_amount / 100 }}
        </template>
      </el-table-column>
      <el-table-column prop="start_time"  label="开始时间" align="center">
        <template #default="scope">
          {{ rfcToTime(scope.row.start_time) }}
        </template>
      </el-table-column>
      <el-table-column prop="end_time" label="结束时间" align="center">
        <template #default="scope">
          {{ rfcToTime(scope.row.end_time) }}
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="使用说明" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="overdue" label="是否过期" align="center">
        <template #default="scope">
          {{ scope.row.overdue ? '已过期' : '未过期' }}
        </template>
      </el-table-column>
      <el-table-column prop="CreatedAt" label="添加时间" align="center">
        <template #default="scope">
          {{ rfcToTime(scope.row.CreatedAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <!-- <el-button type="text" icon="el-icon-user" @click="showUserList(scope.row.id, scope.row.name)">领取列表
          </el-button> -->
          <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.id)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page" :page-size="query.pageSize"
        :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 优惠券弹出框 -->
    <el-dialog :title="active ? '添加优惠券' : '修改优惠券'" v-model="editCouponVisible" width="45%">
      <el-form ref="form" label-width="100px" :model="form" :rules="rules">
        <el-form-item label="单次消费满" prop="re_meet_amount">
          <el-input-number v-model="form.re_meet_amount" :precision="2" :min="0" :controls="false" :max="4294967295" />
          元
        </el-form-item>
        <el-form-item label="优惠金额" prop="re_use_amount">
          <el-input-number v-model="form.re_use_amount" :precision="2" :min="0" :controls="false" :max="4294967295" />
          元
        </el-form-item>
        <el-form-item label="优惠券名称" required>
          <el-input v-model="form.name" class="handle-input"></el-input>
        </el-form-item>
        <el-form-item label="券有效时间" required>
          <el-date-picker v-model="value" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss" align="right" start-placeholder="开始时间" end-placeholder="结束时间"
            :default-time="['0000-00-00 00:00:00', '3000-00-00 23:59:59']" style="margin-right: 10px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="is_validate" label="是否有效：">
              <el-switch v-model="form.is_validate"></el-switch>
            </el-form-item>

        <el-form-item label="使用说明" required>
          <el-input type="textarea" placeholder="请输入使用说明" v-model="form.memo" maxlength="30" resize="none"
            class="textarea" show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editCouponVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveCoupon()">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :title="userNum" v-model="userVisible" width="50%">
      <el-table :data="userList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column prop="ID" label="ID" width="55" align="center">
          <template #default="scope">
            <span>{{ scope.row.user.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="称呼" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.user.real_name || scope.row.user.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="手机号码" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.user.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ useMap.get(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="领取时间" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ rfcToTime(scope.row.CreatedAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <el-button type="text" @click="revokeCoupon(scope.row.ID)"> <svg xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024" width="1em" height="1em">
                <path fill="currentColor"
                  d="M289.088 296.704h92.992a32 32 0 0 1 0 64H232.96a32 32 0 0 1-32-32V179.712a32 32 0 0 1 64 0v50.56a384 384 0 0 1 643.84 282.88 384 384 0 0 1-383.936 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.712-216.448z">
                </path>
              </svg> 撤回优惠券
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="user_query.page"
          :page-size="user_query.pageSize" :total="userPageTotal"
          @current-change="handleUserPageChange"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deleteStoreCoupon, getStoreCoupon, saveStoreCoupon, createStoreCoupon, getCouponUsers, deleteUserCoupon } from "@/api/coupon"
import moment from "moment/moment";
import { getAreaOption, getStoreOption } from "@/api/store";
import { rfcToTime } from "@/utils/defaultTime";
export default {
  name: "CouponTable",
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10
      },
      couponData: [],
      pageTotal: null,
      areaOptions: [],
      area_store: [],
      props: {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      storeMap: new Map(),
      editCouponVisible: false,
      active: false,
      form: {
        name: '',
        meet_amount: null,
        use_amount: null,
        re_meet_amount: null,
        re_use_amount: null,
        start_time: '',
        end_time: '',
        memo: '',
        id: null,
        store_id: null
      },
      area_id: null,
      value: '',
      rules: {
        re_meet_amount: [{ required: true, message: '请设置使用门槛', trigger: 'blur' }],
        re_use_amount: [{ required: true, message: '请输入优惠金额', trigger: 'blur' }]
      },
      formStore: [],
      dealtime: '',
      userList: [],
      userPageTotal: 0,
      userNum: '用户列表（总0人）',
      user_query: {
        page: 1,
        pageSize: 10,
        id: null
      },
      userVisible: false,
      useType: [
        {
          value: 1,
          label: '未使用'
        },
        {
          value: 2,
          label: '已使用'
        },
        {
          value: 3,
          label: '已过期'
        }
      ],
      useMap: new Map(),
    }
  },
  computed: {
    rfcToTime: function () {
      return rfcToTime
    }
  },
  created() {
    this.getData()
    this.getStoreOption()
  },
  methods: {
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    dateRfcHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },
    getuseMap() {
      this.useType.forEach(item => {
        this.useMap.set(item.value, item.label)
      })
    },
    getData() {
      this.query.area_id = this.area_store !== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store !== null && this.area_store.length > 1) ? this.area_store[1] : null
      getStoreCoupon(this.query).then(res => {
        this.couponData = res.data.list
        if (this.query.page === 1) {
          this.pageTotal = res.data.total
        }
      })
    },
    centerStyle() {
      return 'text-align:center'
    },
    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }

    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },
    getStoreOption(id) {
      getStoreOption(id).then(res => {
        this.storeOptions = res
        this.storeOptions.push({ value: 0, label: '平台' })
        res.forEach(item => {
          this.storeMap.set(item.value, item.label)
        })
      })
    },
    getFormStore(id) {
      getStoreOption(id).then(res => {
        this.formStore = res
      })
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 添加操作
    handleAdd() {
      this.active = true
      this.form = {}
      this.form.id = 0
      this.value = null
      this.editCouponVisible = true
    },
    // 编辑操作
    handleEdit(index, row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.value = []
      this.value.push(row.start_time)
      this.value.push(row.end_time)
      this.dealtime = row.getDeadline
      this.active = false
      this.form.re_meet_amount = row.meet_amount / 100
      this.form.re_use_amount = row.use_amount / 100
      this.editCouponVisible = true
    },
    saveCoupon() {
      if ((this.value != null) && (this.value.length != 0)) {
        this.form.start_time = new Date(this.value[0]).toISOString()
        this.form.end_time = new Date(this.value[1]).toISOString()
      } else if (this.value == null) {
        this.form.start_time = null
        this.form.end_time = null
      }
      this.form.meet_amount = this.form.re_meet_amount * 100
      this.form.use_amount = this.form.re_use_amount * 100
      this.form.id = this.form.ID
      if (this.form.id) {
        saveStoreCoupon(JSON.stringify(this.form)).then(res => {
          if (res) {
            this.$message.success('保存成功')
            this.editCouponVisible = false
            this.getData()
          }
        })
      } else {
        createStoreCoupon(JSON.stringify(this.form)).then(res => {
          if (res) {
            this.$message.success('保存成功')
            this.editCouponVisible = false
            this.getData()
          }
        })
      }
    },
    handleDelete(id) {
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteStoreCoupon(id).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.editCouponVisible = false
            this.getData()
          }
        })
      })
    },
    // 优惠券领取列表
    showUserList(id, name) {
      this.getUserList(id)
      this.userTypeName = name
      this.getuseMap()
      this.userVisible = true
    },
    getUserList(id) {
      this.user_query.id = id
      getCouponUsers(this.user_query).then(res => {
        if (res.code === 0) {
          this.userList = res.data.list
          this.userNum = this.userTypeName + '（总' + res.data.total + '人）'
          this.userPageTotal = res.data.total
        }
      })
    },
    revokeCoupon(id) {
      this.$confirm("确定要撤回该优惠券吗？", "撤回提示", {
        type: "warning"
      }).then(() => {
        deleteUserCoupon(JSON.stringify({ id })).then(res => {
          if (res) {
            this.$message.success('撤销成功')
            this.getUserList(this.user_query.id)
          }
        })
      })
    }
  }
}

</script>
<style scoped>
.handle-box {
  margin-bottom: 10px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.textarea {
  width: 400px;
}
</style>